import { Icon } from '@material-ui/core';
import classNames from 'classnames';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { LoadingStatus } from '../../../redux/reducers/LoadingStatusReducer';
import CircularProgress from '../CircularProgress';

export interface NegotiationCountProps extends NegotiationCountHandler {
  /**
   * id. `total`, `doing`, `pending`, `done`
   */
  id: string;
  /**
   * タイトル
   */
  title: string;
  /**
   * メイン集計単位
   */
  mainCountUnit: string;
  /**
   * 件数
   */
  count: number | string;
  /**
   * 件数（括弧）
   */
  additionalCount: number | string;
  /**
   * リンク先があるかどうか
   */
  isLinkEnable: boolean;
  /**
   * リンク先
   */
  linkto: string;
  /**
   * ローディング中かどうか
   */
  isLoading?: boolean;
  /**
   * リンク先があるかどうか
   */
  isBrackets: boolean;

  loadingStatus: LoadingStatus;

  gaSpotEvent?: string;
}

class NegotiationCount extends Component<NegotiationCountProps, {}> {
  /* 初回の描画完了後に呼ばれる */
  componentDidMount() {
    if (!this.props.gaSpotEvent) return;
    document.getElementById(`negotiationCount-link-${this.props.id}`)?.setAttribute('onclick', this.props.gaSpotEvent);
  }

  render() {
    return (
      <Link
        to={this.props.linkto}
        onClick={() => this.props.handleClick(this.props.id, this.props.loadingStatus.result?.jobDateTime)}
        className={classNames(
          'dashboard-summary',
          this.props.isLinkEnable && 'dashboard-summary--link',
          `dashboard-summary--${this.props.id}`
        )}
        id={`negotiationCount-link-${this.props.id}`}
        data-testid-e2e={`negotiationCount-link-${this.props.id}`}>
        <div className={classNames('dashboard-summary-icon-wrap', `dashboard-summary-icon-wrap--${this.props.id}`)}>
          <Icon className='dashboard-summary-icon'>{getDashboardSummaryIcon(this.props.id)}</Icon>
        </div>
        <div data-testid='summary_title' className='dashboard-summary__title'>
          {this.props.title}
        </div>
        {this.props.isLoading ? (
          <div className='u-text-center'>
            <CircularProgress isIndeterminate radius={16} stroke={3} hasBackground={false} />
          </div>
        ) : (
          <div data-testid='summary_value' data-testid-e2e='negotiationCount-summary_value' className='dashboard-summary__value'>
            {this.props.count}
            {this.props.mainCountUnit === 'negotiation' ? '件' : '人'}
            <span className='dashboard-summary__subtitle'>
              {this.props.isBrackets && `（${this.props.additionalCount}${this.props.mainCountUnit === 'negotiation' ? '人' : '件'}）`}
            </span>
          </div>
        )}
      </Link>
    );
  }
}

export interface NegotiationCountHandler {
  handleClick(id: string, jobDateTime?: string): void;
}

export default NegotiationCount;

function getDashboardSummaryIcon(id: string): string {
  switch (id) {
    case 'total':
      return 'list_bulleted';
    case 'noneNegotiation':
      return 'person';
    case 'noneProduct':
      return 'comment';
    default:
      return 'description';
  }
}
